export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST'
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS'
export const LOGIN_USER_ERROR = 'LOGIN_USER_ERROR'
export const RESET_ERROR_STATE = 'RESET_ERROR_STATE'
export const RESET_FORM_DATA = 'RESET_FORM_DATA'
export const PERIMETERX_ENABLED = 'PERIMETERX_ENABLED'
